"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _auth = require("@/utils/auth");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var _timeUtil = require("@/utils/time-util");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      form: [{
        id: null,
        file_type: 0,
        file_url: '',
        client_id: '',
        is_acceptance: false,
        title: '',
        create_date: '',
        date_of_acceptance: '',
        attach_file_type: 1,
        file_name: ''
      }],
      submitBtnName: '追加',
      loading: false
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setClientDocumentID)(this.$route.params.id);
            }
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.GET_CLIENT_CONTRACT,
              variables: {
                id: (0, _auth.getClientDocumentID)()
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 1:
            res = _context.sent;
            this.$data.form = res.data.client_file_link;
            _context.next = 2;
            return (0, _appUtil.checkReadingFlag)(true);
          case 2:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 3;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    backToIndex: function backToIndex() {
      return this.$router.push({
        name: 'AttendanceIndex'
      });
    },
    displayAcceptanceType: function displayAcceptanceType(val) {
      if (val === _DocumentCategory.DocumentCategory.Acceptance.TRUE.val) {
        return _DocumentCategory.DocumentCategory.Acceptance.TRUE.label;
      }
      return _DocumentCategory.DocumentCategory.Acceptance.FALSE.label;
    },
    displayDocumentType: function displayDocumentType(val) {
      if (val === _DocumentCategory.DocumentCategory.UserDocumentType.Contract.val) {
        return _DocumentCategory.DocumentCategory.UserDocumentType.Contract.label;
      } else if (val === _DocumentCategory.DocumentCategory.UserDocumentType.EmploymentStatement.val) {
        return _DocumentCategory.DocumentCategory.UserDocumentType.EmploymentStatement.label;
      }
      return '未設定';
    },
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    }
  }
};